import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, finalize, takeUntil, tap } from 'rxjs/operators';
import { ModalService } from '../services/modal/modal.service';
import { JsonPipe } from '@angular/common';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(
    private readonly modalService: ModalService,
    private readonly jsonPipe: JsonPipe
  ) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((event: HttpErrorResponse) => {
        const requestUrl = event.url.split("?")[0]
        const splitedUrl = requestUrl.split("/")
        const functionName = splitedUrl[splitedUrl.length - 1]
        const apisToPopErrorModal = ["GetRoutes", "GetRouteFullData", "GetTripCalendar", "GetRouteDailyCalendar", "GetStopFullData", "GetIntercityLines"]
        if(apisToPopErrorModal.includes(functionName)) {
          this.modalService.openErrorModal(event);
        }
        return throwError(() => event);
      })
    );
  }
}
